import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.UAT';
import { ReassignmentService } from '../../services/reassignment/reassignment.service';
import { ModalController, ToastController } from '@ionic/angular';
import { saveAs } from 'file-saver';
import * as ExcelJS from 'exceljs';

@Component({
  selector: 'app-success-summary',
  templateUrl: './success-summary.component.html',
  styleUrls: ['./success-summary.component.scss'],
})
export class SuccessSummaryComponent {
  constructor(
    private dialogRef: MatDialogRef<SuccessSummaryComponent>,
    private router: Router,
    private dialog: MatDialog,
    private toastController: ToastController,
    private reassignmentService: ReassignmentService,
    @Inject(MAT_DIALOG_DATA) public data: { total: number; success: number; failure: number; updateList: any[]; fileName: string }
  ) { }

  close() {
    this.dialogRef.close();
  }


  goToUploadHistory() {
    this.dialogRef.close({ goToHistory: true });
  }

  async downloadUpdatedRecords() {
    const updateList = this.data?.updateList;

    if (!updateList || updateList.length === 0) {
      const toast = await this.toastController.create({
        message: 'No updated records available to download',
        duration: 3000,
        position: 'bottom',
        cssClass: 'brand-toast'
      });
      await toast.present();
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reassignment Update Summary');

    const headerConfig = [
      { key: 'folioNo', label: 'Folio No' },
      { key: 'applicationNo', label: 'Application No' },
      { key: 'investorName', label: 'Investor Name' },
      { key: 'pan', label: 'PAN' },
      { key: 'fundId', label: 'Fund ID' },
      { key: 'fundName', label: 'Fund Name' },
      { key: 'distributorARN', label: 'Distributor ARN' },
      { key: 'distributorName', label: 'Distributor Name' },
      { key: 'existingRMName', label: 'Existing RM Name' },
      { key: 'existingRMEmail', label: 'Existing RM Email' },
      { key: 'existingRMCode', label: 'Existing RM Code' },
      { key: 'existingCXOName', label: 'Existing CXO Name' },
      { key: 'existingCXOEmail', label: 'Existing CXO Email' },
      { key: 'existingCXOMobile', label: 'Existing CXO Mobile' },
      { key: 'newRMName', label: 'New RM Name' },
      { key: 'newRMEmail', label: 'New RM Email' },
      { key: 'newRMCode', label: 'New RM Code' },
      { key: 'newCXOName', label: 'New CXO Name' },
      { key: 'newCXOEmail', label: 'New CXO Email' },
      { key: 'newCXOMobile', label: 'New CXO Mobile' },
      { key: 'recordStatus', label: 'Record Status' },
      { key: 'reason', label: 'Reason' },
    ];

    // ✅ Header row
    const headerRow = worksheet.addRow(headerConfig.map(h => h.label));

    // ✅ Header styling
    headerRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9D9D9' }
      };
      cell.alignment = { horizontal: 'left', vertical: 'middle' };
    });

    // ✅ Data rows
    updateList.forEach(row => {
      const addedRow = worksheet.addRow(
        headerConfig.map(h => row[h.key] ?? '')
      );

      addedRow.eachCell(cell => {
        cell.alignment = { horizontal: 'left', vertical: 'middle' };
      });
    });

    // ✅ Freeze header
    worksheet.views = [{ state: 'frozen', ySplit: 1 }];

    // ✅ Auto‑fit columns
    worksheet.columns.forEach(col => {
      let max = 12;
      col.eachCell({ includeEmpty: true }, cell => {
        max = Math.max(max, cell.value?.toString().length || 0);
      });
      col.width = Math.min(max + 4, 40);
    });

    // ✅ Create and download file
    const buffer = await workbook.xlsx.writeBuffer();

    const now = new Date();
    const fileName =
      `Reassignment_Update_Summary_` +
      `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

    saveAs(
      new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      fileName
    );

    const toast = await this.toastController.create({
      message: 'Update summary Excel downloaded successfully',
      duration: 3000,
      position: 'bottom',
      cssClass: 'brand-toast'
    });
    await toast.present();
  }

}
